import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Table, Button, Flex, Popconfirm } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { semesterLabel } from '../../../../../../const/semesterLabel';

const { table, actionSection } = courseStruct;

export const Supervision = ({ courses, updateSemester, apaPoint, semesterName, status }) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;

  const { supervision_course: supervisionCourse } = staticData;
  const defaultCourse = supervisionCourse?.length > 0 ? supervisionCourse[0] : {};
  const { value } = defaultCourse;

  const [_courses, setCourses] = useState(courses?.length > 0 ? courses : []);
  const handleCourses = (courses) => setCourses(courses);

  const handleAdd = () => {
    const newPlaning = {
      key: getRandomId(),
      name: value,
      no_student: 0,
      section: '',
      attachment: []
    };
    handleCourses([..._courses, newPlaning]);
  };

  const handleSave = (row) => {
    const currentCourses = [..._courses];
    const index = currentCourses.findIndex((item) => row.key === item.key);
    const item = currentCourses[index];

    currentCourses.splice(index, 1, {
      ...item,
      ...row
    });
    handleCourses(currentCourses);
  };

  const handleDelete = (key) => {
    const newData = _courses.filter((item) => item.key !== key);
    handleCourses(newData);
  };

  const columns = [
    ...TableCol(handleSave, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => {
        const { key } = record;

        return (
          <Popconfirm
            title="Sure to delete?"
            disabled={status === 1 || status === 2 || status === 3}
            onConfirm={() => handleDelete(key)}
          >
            <a>Delete</a>
          </Popconfirm>
        );
      }
    }
  ];

  useEffect(() => {
    updateSemester(semesterName, _courses);
  }, [_courses, semesterName]);

  return courses ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={_courses}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={columns.length - 2} align="right">
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell colSpan={2}>{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />

      <Flex {...actionSection}>
        <Button disabled={status === 1 || status === 2 || status === 3} onClick={handleAdd} className="glow-btn">
          Add New Item
        </Button>{' '}
      </Flex>
    </>
  ) : (
    <></>
  );
};